// Third party components
import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Grid, Typography } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import Link from '@mui/material/Link';
import { formatValue } from 'helpers';

const ActivityItemDetails = (activity, detailsConfig) => {

  return (
    <>
      <Grid container spacing={2} sx={{ paddingTop: 3 }}>

        {/* Cycle through config and dynamically generate the details view */}
        {detailsConfig && detailsConfig?.sort((a, b) => a.order - b.order).map((detail, detailIndex) => {
          return (
            <React.Fragment key={detailIndex}>
              {/* Label */}
              <Grid item xs={3} sx={{ paddingTop: 3 }}>
                <strong>{detail?.label || 'Label'}: </strong>
              </Grid>

              {/* Data */}
              <Grid item xs={3} alignItems="center" justify="flex-end">
                {formatValue(activity, detail)}
              </Grid>
            </React.Fragment>
          );
        }) || []}

        {/* Link row */}
        <Grid item xs={12} sx={{ paddingTop: 3, textAlign: 'right' }}>
          <Link href={`/activities/${activity?.id}`}
          ><strong>Go to Activity</strong></Link>
        </Grid>

      </Grid>
    </>
  );
}


const ActivitiesList = ({ activities, detailsConfig, singularName }) => {
  const activitiesCount = activities?.length - 1;

  if (!activities || activities.length === 0) {
    return (<>
      <Typography sx={{ paddingTop: 3 }}>There are no activities associated to this {singularName}.</Typography>
    </>);
  }

  return (
    <>
      {activities.length && activities.map((activity, activityIndex) => {
        // Used to determine where to put dividers
        let isLast = activityIndex === activitiesCount;
        return (
          <React.Fragment key={activityIndex}>
            <ListItem sx={{ paddingBottom: 3, paddingLeft:3, marginLeft: 3 }}>
              {ActivityItemDetails(activity, detailsConfig)}
            </ListItem>

            {isLast ? (<></>) : (<Divider />)}
          </React.Fragment>
        );
      })}
    </>
  )
}

ActivitiesList.propTypes = {
  activities: PropTypes.array,
  singularName: PropTypes.string,
  detailsConfig: PropTypes.arrayOf(PropTypes.shape({
    order: PropTypes.number,
    label: PropTypes.string,
    field: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    isDate: PropTypes.bool,
  })),
}

ActivityItemDetails.propTypes = {
  activity: PropTypes.object,
  isLast: PropTypes.bool,
  detailsConfig: PropTypes.arrayOf(PropTypes.shape({
    order: PropTypes.number,
    label: PropTypes.string,
    field: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    isDate: PropTypes.bool,
  })),
}

export default ActivitiesList;
